import { Compass, Phone } from "lucide-react";

const NAV = [
  { label: "Leistungen", href: "/leistungen", id: "leistungen" },
  { label: "Visa", href: "/visa", id: "visa" },
  { label: "Ablauf", href: "/ablauf", id: "ablauf" },
  { label: "Über uns", href: "/ueber-uns", id: "ueber-uns" },
  { label: "Ratgeber", href: "/ratgeber", id: "ratgeber" },
  { label: "FAQ", href: "/faq", id: "faq" },
  { label: "Kontakt", href: "/kontakt", id: "kontakt" },
];

const VISA_LINKS = [
  { label: "E-2 Visum (Unternehmervisum)", href: "/visa/e-2-visum" },
  { label: "EB-2 NIW – Green Card ohne Arbeitgeber", href: "/visa/eb-2-niw-greencard" },
  { label: "EB-1C – Green Card für Manager", href: "/visa/eb-1c-greencard" },
  { label: "L-1A – Visum für Führungskräfte", href: "/visa/l-1a-visum" },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-line bg-sand py-16"
    >
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-6 sm:grid-cols-2 lg:grid-cols-3 lg:px-10">
        <div>
          <a href="/" data-testid="footer-brand-link" className="flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center bg-clay text-sand">
              <Compass className="h-5 w-5" strokeWidth={1.5} />
            </span>
            <span className="font-serif text-base leading-tight">
              Florida Business <span className="italic text-clay">&amp;</span> Relocation
            </span>
          </a>
          <p className="mt-6 max-w-xs text-sm leading-relaxed text-ink-muted">
            Relocation &amp; Unternehmensberatung für Deutsche und Schweizer in
            Florida. Auswandern. Gründen. Ankommen.
          </p>
          <div className="mt-6 space-y-2 text-sm" data-testid="footer-contact">
            <a
              href="tel:+13055294140"
              data-testid="footer-phone-link"
              className="flex items-center gap-2 text-ink-muted transition-colors hover:text-clay"
            >
              <Phone className="h-4 w-4 shrink-0 text-clay" />
              +1 305 529 4140
            </a>
          </div>
          <a
            href="/kontakt"
            data-testid="footer-cta-button"
            className="mt-8 inline-block bg-clay px-6 py-3 text-xs uppercase tracking-[0.2em] text-sand transition-colors hover:bg-clay-dark"
          >
            Erstgespräch buchen
          </a>
        </div>

        <div>
          <h3 className="text-xs uppercase tracking-[0.2em] text-ink">Navigation</h3>
          <ul className="mt-6 space-y-3">
            {NAV.map((item) => (
              <li key={item.id}>
                <a
                  href={item.href}
                  data-testid={`footer-nav-${item.id}`}
                  className="text-sm text-ink-muted transition-colors hover:text-clay"
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="text-xs uppercase tracking-[0.2em] text-ink">
            Visa &amp; Green Card
          </h3>
          <ul className="mt-6 space-y-3">
            {VISA_LINKS.map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  data-testid={`footer-visa-${item.href.split("/").pop()}`}
                  className="text-sm text-ink-muted transition-colors hover:text-clay"
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
          <p className="mt-6 text-sm leading-relaxed text-ink-muted">
            Wir prüfen im kostenlosen Erstgespräch, welcher Weg zu Ihrem Profil
            passt – und begleiten Ihr gesamtes Verfahren persönlich auf
            Deutsch.
          </p>
        </div>
      </div>

      <div className="mx-auto mt-16 flex max-w-7xl flex-col gap-4 border-t border-line px-6 pt-8 text-xs text-ink-muted sm:flex-row sm:items-center sm:justify-between lg:px-10">
        <p data-testid="footer-copyright">
          © {new Date().getFullYear()} Florida Business &amp; Relocation. Alle
          Rechte vorbehalten.
        </p>
        <div className="flex gap-6">
          <a
            href="/impressum"
            data-testid="footer-impressum-link"
            className="text-ink-muted transition-colors hover:text-clay"
          >
            Impressum
          </a>
          <a
            href="/datenschutz"
            data-testid="footer-datenschutz-link"
            className="text-ink-muted transition-colors hover:text-clay"
          >
            Datenschutz
          </a>
        </div>
      </div>
    </footer>
  );
}
